"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "role-section-block-container" };
const _hoisted_2 = { class: "role-block-name" };
const vue_3 = require("vue");
const common_1 = require("../../common/common");
const models_1 = require("../../js/models");
const RoleSectionBlock_vue_1 = __importDefault(require("./RoleSectionBlock.vue"));
const roleTimeLayout_1 = require("../roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleTimeBlock',
    props: {
        role: {},
        timeRange: {}
    },
    setup(__props) {
        const props = __props;
        const slotTimeRange = (0, vue_3.computed)(() => {
            const { from, to } = props.role;
            const { start: rangeStart, end: rangeEnd } = props.timeRange;
            const timelineStart = rangeStart * 60;
            const timelineEnd = rangeEnd * 60;
            const slotStart = (0, common_1.kitchenTimeToDuration)(from || "", "minutes");
            const slotEnd = (0, common_1.kitchenTimeToDuration)(to || "", "minutes");
            const { start, end } = (0, roleTimeLayout_1.clampTimeSpanToTimeline)(slotStart, slotEnd, timelineStart, timelineEnd);
            return {
                start,
                end,
            };
        });
        const sectionLanes = (0, vue_3.computed)(() => (0, roleTimeLayout_1.calculateRoleTimeLayout)(props.role.roleSections, props.timeRange));
        const isBlockVisible = (0, vue_3.computed)(() => {
            const { start: timelineStart, end: timelineEnd } = props.timeRange;
            const { start, end } = slotTimeRange.value;
            return (0, roleTimeLayout_1.isTimelineBlockVisible)(start, end, timelineStart * 60, timelineEnd * 60);
        });
        const blockStyle = (0, vue_3.computed)(() => {
            const { start: rangeStart, end: rangeEnd } = props.timeRange;
            const { color, roleSections } = props.role;
            const hasSections = roleSections && roleSections.length > 0;
            const timelineStart = rangeStart * 60;
            const timelineEnd = rangeEnd * 60;
            const { start, end } = slotTimeRange.value;
            const isDefaultColor = !color || color === models_1.OPLUS_COLOR_PALETTE.DEFAULT;
            const timelineHeight = (0, roleTimeLayout_1.calculateRoleTimeHeight)(sectionLanes.value.laneCount);
            return (0, roleTimeLayout_1.calculateTimelineBlockStyle)(start, end, timelineStart, timelineEnd, {
                minHeight: timelineHeight,
                background: hasSections ? (0, roleTimeLayout_1.getSlotBackground)(color) : `#${color || models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: isDefaultColor ? "#3b4351" : "#fff",
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["role-time-block", { 'is-hidden': !isBlockVisible.value }]),
                style: (0, vue_2.normalizeStyle)(blockStyle.value)
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.role.roleSections, (rs) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleSectionBlock_vue_1.default, {
                            key: rs.id,
                            "role-section": rs,
                            "time-range": slotTimeRange.value,
                            "lane-index": sectionLanes.value.laneBySectionId.get(rs.id) ?? 0
                        }, null, 8 /* PROPS */, ["role-section", "time-range", "lane-index"]));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (0, vue_2.createElementVNode)("p", _hoisted_2, (0, vue_2.toDisplayString)(__props.role.name), 1 /* TEXT */)
                ])
            ], 6 /* CLASS, STYLE */));
        };
    }
});
